const coderAvatarSvg = `<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="10" rx="2"/>
                <circle cx="12" cy="5" r="2"/>
                <path d="M12 7v4M8 16h.01M16 16h.01"/>
                </svg>`;

function initAiAssist() {
    const chatModal = document.getElementById('chatModal');
    if (!chatModal) {
        console.error('Chat widget: chatModal not found');
        return;
    }

    const chatBody = chatModal.querySelector('#chatBody');
    const chatInput = chatModal.querySelector('#chatInput');
    const chatSend = chatModal.querySelector('#chatSend');
    const chatReset = chatModal.querySelector('#chatReset');
    const chatQuick = chatModal.querySelector('#chatQuick');
    const chatQuickWrap = chatModal.querySelector('#chatQuickWrap');
    const chatQuickScrollButtons = chatModal.querySelectorAll('[data-chat-quick-scroll]');
    const chatStatus = chatModal.querySelector('#chatStatus');

    if (!chatBody || !chatInput || !chatSend || !chatReset || !chatStatus) {
        console.error('Chat widget: required modal elements not found');
        return;
    }

    //const API_BASE = 'http://localhost:8765';
    const API_BASE = 'https://ai.toprogram.ru';
    const WIDGET_ID = chatModal.dataset.widgetId || 'site_widget_main';

    const STORAGE_KEYS = {
        sessionId: 'mk_chat_session_id',
        clientId: 'mk_chat_client_id',
    };

    const chatState = {
        sessionId: null,
        wsToken: null,
        socket: null,
        isConnecting: false,
        isReady: false,
        isSending: false,
        typingEl: null,
    };

    resetChatUi();

    function setStatus(text) {
        chatStatus.innerHTML = `<span class="chat-head__dot"></span>${text}`;
    }

    function formatTime() {
        const now = new Date();
        return now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    function escapeHtml(str) {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    }

    function appendMessage(role, text) {
        const msg = document.createElement('div');
        msg.className = `msg msg--${role === 'user' ? 'user' : 'bot'}`;

        msg.innerHTML = `
            <div class="msg__avatar">${role === 'user' ? 'Вы' : coderAvatarSvg}</div>
            <div>
                <div class="msg__bubble">${escapeHtml(String(text)).replace(/\n/g, '<br>')}</div>
                <div class="msg__time">${formatTime()}</div>
            </div>
        `;

        chatBody.appendChild(msg);
        chatBody.scrollTop = chatBody.scrollHeight;
    }

    function showTyping() {
        hideTyping();

        const wrapper = document.createElement('div');
        wrapper.className = 'msg msg--bot';
        wrapper.id = 'chatTyping';

        wrapper.innerHTML = `
            <div class="msg__avatar">${coderAvatarSvg}</div>
            <div>
                <div class="msg__bubble">Печатает...</div>
                <div class="msg__time">${formatTime()}</div>
            </div>
        `;

        chatBody.appendChild(wrapper);
        chatBody.scrollTop = chatBody.scrollHeight;
        chatState.typingEl = wrapper;
        setStatus('печатает...');
    }

    function hideTyping() {
        if (chatState.typingEl) {
            chatState.typingEl.remove();
            chatState.typingEl = null;
        }

        if (chatState.isReady) {
            setStatus('онлайн');
        }
    }

    function setSendDisabled(disabled) {
        chatSend.disabled = disabled;
        chatInput.disabled = disabled;
    }

    function focusChatInput() {
        if (chatInput.disabled) {
            return;
        }

        window.requestAnimationFrame(() => {
            chatInput.focus({ preventScroll: true });
        });
    }

    function updateQuickScrollControls() {
        if (!chatQuick || !chatQuickWrap) {
            return;
        }

        const maxScrollLeft = Math.max(0, chatQuick.scrollWidth - chatQuick.clientWidth);
        const isOverflowing = maxScrollLeft > 1;
        const isStart = chatQuick.scrollLeft <= 1;
        const isEnd = chatQuick.scrollLeft >= maxScrollLeft - 1;

        chatQuickWrap.classList.toggle('is-overflowing', isOverflowing);
        chatQuickWrap.classList.toggle('is-start', !isOverflowing || isStart);
        chatQuickWrap.classList.toggle('is-end', !isOverflowing || isEnd);

        chatQuickScrollButtons.forEach((button) => {
            const direction = button.dataset.chatQuickScroll;
            button.disabled = !isOverflowing || (direction === 'left' && isStart) || (direction === 'right' && isEnd);
        });
    }

    function scrollQuickButtons(direction) {
        if (!chatQuick) {
            return;
        }

        const distance = Math.max(180, Math.floor(chatQuick.clientWidth * 0.72));
        chatQuick.scrollBy({
            left: direction === 'left' ? -distance : distance,
            behavior: 'smooth',
        });
    }

    function scheduleQuickScrollControlsUpdate() {
        window.requestAnimationFrame(updateQuickScrollControls);
        window.setTimeout(updateQuickScrollControls, 150);
    }

    function getClientId() {
        let clientId = localStorage.getItem(STORAGE_KEYS.clientId);

        if (!clientId) {
            clientId = (window.crypto && crypto.randomUUID)
                ? crypto.randomUUID()
                : `client_${Date.now()}_${Math.random().toString(16).slice(2)}`;

            localStorage.setItem(STORAGE_KEYS.clientId, clientId);
        }

        return clientId;
    }

    async function initSession() {
        if (chatState.isConnecting || chatState.isReady) return;

        chatState.isConnecting = true;
        setStatus('подключение...');

        try {
            const payload = {
                widget_id: WIDGET_ID,
                page_url: window.location.href,
                client_id: getClientId(),
            };

            const response = await fetch(`${API_BASE}/api/v1/widget/session/init`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error(`Не удалось инициализировать сессию (${response.status})`);
            }

            const data = await response.json();

            chatState.sessionId = data.session_id;
            chatState.wsToken = data.ws_token;

            localStorage.setItem(STORAGE_KEYS.sessionId, data.session_id);

            await connectSocket();
        } finally {
            chatState.isConnecting = false;
        }
    }

    async function connectSocket() {
        return new Promise((resolve, reject) => {
            const wsUrl = new URL(`${API_BASE.replace(/^http/i, 'ws')}/api/v1/chat/ws`);
            wsUrl.searchParams.set('session_id', chatState.sessionId);
            wsUrl.searchParams.set('token', chatState.wsToken);

            const socket = new WebSocket(wsUrl.toString());

            socket.addEventListener('open', () => {
                chatState.socket = socket;
                chatState.isReady = true;
                setStatus('онлайн');
                resolve();
            });

            socket.addEventListener('message', (event) => {
                try {
                    const data = JSON.parse(event.data);
                    handleSocketMessage(data);
                } catch (e) {
                    console.error('WS parse error', e, event.data);
                }
            });

            socket.addEventListener('close', () => {
                chatState.isReady = false;
                chatState.socket = null;
                setStatus('не в сети');
            });

            socket.addEventListener('error', (e) => {
                setStatus('ошибка соединения');
                reject(e);
            });
        });
    }

    function handleSocketMessage(data) {
        switch (data.type) {
            case 'assistant_typing':
                showTyping();
                break;

            case 'assistant_message':
                hideTyping();
                appendMessage('bot', data.text || '');
                setSendDisabled(false);
                focusChatInput();
                chatState.isSending = false;
                break;

            case 'lead_created':
                hideTyping();
                if (data.text) {
                    appendMessage('bot', data.text);
                }
                setSendDisabled(false);
                focusChatInput();
                chatState.isSending = false;
                break;

            case 'error':
                hideTyping();
                appendMessage('bot', data.message || 'Произошла ошибка. Попробуйте ещё раз.');
                setSendDisabled(false);
                focusChatInput();
                chatState.isSending = false;
                break;

            default:
                console.warn('Unknown WS message type:', data);
                break;
        }
    }

    async function ensureConnection() {
        if (chatState.isReady && chatState.socket) return;
        await initSession();
    }

    async function sendMessage(text) {
        const cleanText = String(text || '').trim();

        if (!cleanText) return;
        if (chatState.isSending) return;

        await ensureConnection();

        if (!chatState.socket || chatState.socket.readyState !== WebSocket.OPEN) {
            throw new Error('WebSocket is not connected');
        }

        chatState.isSending = true;
        appendMessage('user', cleanText);
        showTyping();
        setSendDisabled(true);

        chatState.socket.send(JSON.stringify({
            type: 'user_message',
            text: cleanText,
        }));
    }

    function getInputValue() {
        const currentInput = chatModal.querySelector('#chatInput');
        return currentInput ? currentInput.value : '';
    }

    function clearInput() {
        const currentInput = chatModal.querySelector('#chatInput');
        if (!currentInput) return;

        currentInput.value = '';
        currentInput.style.height = 'auto';
    }

    async function handleSubmit(rawText = null) {
        const sourceText = rawText !== null ? String(rawText) : getInputValue();
        const cleanText = sourceText.trim();

        if (!cleanText) return;

        clearInput();

        try {
            await sendMessage(cleanText);
        } catch (err) {
            console.error(err);
            hideTyping();
            appendMessage('bot', 'Ошибка отправки сообщения. Попробуйте ещё раз.');
            setSendDisabled(false);
            focusChatInput();
            chatState.isSending = false;
        }
    }

    function resetChatUi() {
        hideTyping();
        chatBody.innerHTML = ``;

        appendMessage('bot', `👋 Привет! Я Кодер — AI-ассистент Мастерской кода.`);
        appendMessage('bot', `Помогу подобрать решение под ваш проект, рассчитать сроки и стоимость, или сразу соединю с Евгением. \n\n С чего начнём?`);

    }

    function resetSession() {
        setStatus('не подключен');
        if (chatState.socket) {
            try {
                chatState.socket.close();
            } catch (e) {
                console.warn('Socket close error', e);
            }
        }

        chatState.sessionId = null;
        chatState.wsToken = null;
        chatState.socket = null;
        chatState.isReady = false;
        chatState.isConnecting = false;
        chatState.isSending = false;

        localStorage.removeItem(STORAGE_KEYS.sessionId);
        resetChatUi();
        setSendDisabled(false);
        clearInput();
        focusChatInput();
    }

    function getPrefillText(trigger) {
        const sourceInput = trigger
            .closest('.input-row, form, section')
            ?.querySelector('[data-chat-prefill-input], input[type="text"], textarea');

        if (!sourceInput) {
            return '';
        }

        const text = sourceInput.value.trim();

        if (text) {
            sourceInput.value = '';
        }

        return text;
    }

    document.querySelectorAll('[data-open-chat]').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
            e.preventDefault();
            const prefillText = getPrefillText(btn);

            chatModal.classList.add('is-open');
            scheduleQuickScrollControlsUpdate();

            try {
                await ensureConnection();
                scheduleQuickScrollControlsUpdate();

                if (prefillText) {
                    await handleSubmit(prefillText);
                } else {
                    focusChatInput();
                }
            } catch (err) {
                console.error(err);
                appendMessage('bot', 'Не удалось подключить чат. Попробуйте чуть позже.');
                setStatus('ошибка подключения');
                focusChatInput();
            }
        });
    });

    document.querySelectorAll('[data-chat-prefill-input]').forEach((input) => {
        input.addEventListener('keydown', (e) => {
            if (e.key !== 'Enter' || e.shiftKey) {
                return;
            }

            const openButton = input
                .closest('.input-row, form, section')
                ?.querySelector('[data-open-chat]');

            if (!openButton) {
                return;
            }

            e.preventDefault();
            openButton.click();
        });
    });

    chatModal.querySelectorAll('[data-close]').forEach((el) => {
        el.addEventListener('click', () => {
            chatModal.classList.remove('is-open');
        });
    });

    chatSend.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await handleSubmit();
        focusChatInput();
    });

    chatInput.addEventListener('keydown', async (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            e.stopPropagation();
            await handleSubmit();
            focusChatInput();
        }
    });

    chatInput.addEventListener('input', () => {
        chatInput.style.height = 'auto';
        chatInput.style.height = `${Math.min(chatInput.scrollHeight, 120)}px`;
    });

    if (chatQuick) {
        chatQuick.addEventListener('click', async (e) => {
            const btn = e.target.closest('.quick-btn');
            if (!btn) return;

            const text = btn.dataset.message || btn.textContent || '';
            await handleSubmit(text);
        });

        chatQuick.addEventListener('scroll', updateQuickScrollControls, { passive: true });
        window.addEventListener('resize', updateQuickScrollControls);
        window.requestAnimationFrame(updateQuickScrollControls);
        window.setTimeout(updateQuickScrollControls, 250);
    }

    chatQuickScrollButtons.forEach((button) => {
        button.addEventListener('click', () => {
            scrollQuickButtons(button.dataset.chatQuickScroll);
            window.setTimeout(updateQuickScrollControls, 260);
        });
    });

    chatReset.addEventListener('click', () => {
        resetSession();
        ensureConnection();
    });

    setStatus('не подключен');
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAiAssist);
} else {
    initAiAssist();
}
